// src/pages/tag/TagCreatePage.tsx
// Auto-generated by corebuilder. Edit freely.

import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { observer } from '@react';
import { useTag, useI18n } from '@react/hooks';
import {
  Button,
  Input,
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
  CardFooter,
  ErrorAlert,
} from '@react/components';

/**
 * Tag create page.
 */
export const TagCreatePage = observer(() => {
  const navigate = useNavigate();
  const store = useTag();
  const { t } = useI18n();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    color: '',
    icon: '',
    scope_product_id: '',
    created_by: '',
    usage_count: 0,
    metadata: '',
  });

  const handleChange = (field: string, value: string | number | boolean) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await store.CreateTag(formData as any);
      navigate('/tags');
    } catch {
      // Error is handled by store
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <nav className="text-sm mb-2">
          <Link to="/tags" className="text-muted-foreground hover:text-foreground">
            {t('tag.list')}
          </Link>
          <span className="mx-2 text-muted-foreground">/</span>
          <span className="text-foreground">{t('common.create')}</span>
        </nav>
        <h1 className="text-2xl font-bold text-foreground">{t('tag.create')}</h1>
      </div>

      {store.error ? <ErrorAlert error={store.error} dismissible onDismiss={() => store.clearError()} /> : null}

      <form onSubmit={handleSubmit}>
        <Card>
          <CardHeader>
            <CardTitle>{t('tag.details')}</CardTitle>
            <CardDescription>{t('tag.fillInfo')}</CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <Input
              label="Name"
              type="text"
              value={formData.name}
              onChange={(e) => handleChange('name', e.target.value)}
              placeholder="Name"
              required
            />
            <Input
              label="Description"
              type="text"
              value={formData.description}
              onChange={(e) => handleChange('description', e.target.value)}
              placeholder="Description"
            />
            <Input
              label="Color"
              type="text"
              value={formData.color}
              onChange={(e) => handleChange('color', e.target.value)}
              placeholder="Color"
              required
            />
            <Input
              label="Icon"
              type="text"
              value={formData.icon}
              onChange={(e) => handleChange('icon', e.target.value)}
              placeholder="Icon"
            />
            <Input
              label="Scope Product Id"
              type="text"
              value={formData.scope_product_id}
              onChange={(e) => handleChange('scope_product_id', e.target.value)}
              placeholder="Scope Product Id"
            />
            <Input
              label="Created By"
              type="text"
              value={formData.created_by}
              onChange={(e) => handleChange('created_by', e.target.value)}
              placeholder="Created By"
              required
            />
            <Input
              label="Usage Count"
              type="number"
              value={formData.usage_count}
              onChange={(e) => handleChange('usage_count', Number(e.target.value))}
              placeholder="Usage Count"
              required
            />
            <Input
              label="Metadata"
              type="text"
              value={formData.metadata}
              onChange={(e) => handleChange('metadata', e.target.value)}
              placeholder="Metadata"
              required
            />
          </CardContent>
          <CardFooter className="flex justify-end gap-3">
            <Link to="/tags">
              <Button type="button" variant="secondary">{t('common.cancel')}</Button>
            </Link>
            <Button type="submit" disabled={isSubmitting}>
              {isSubmitting ? t('common.creating') : t('tag.create')}
            </Button>
          </CardFooter>
        </Card>
      </form>
    </div>
  );
});

export default TagCreatePage;
